/**
 * Módulo Bloco Imagem/Texto
 * Renderiza bloco de texto principal
 */

import BaseModule from './BaseModule.js';

export default class BlocoImagemTextoModule extends BaseModule {
    static defaultConfig = {
        container: null,
        cssPrefix: 'mzk-bloco',
        animateIn: true
    };

    constructor(config = {}) {
        super({ ...BlocoImagemTextoModule.defaultConfig, ...config });
        this.data = null;
    }

    /**
     * Inicializa o módulo
     */
    async init() {
        if (!this.config.data) {
            throw new Error('BlocoImagemTextoModule requer data na configuração');
        }

        this.data = this.config.data;
        this.initialized = true;
    }

    /**
     * Renderiza o bloco
     */
    render(container) {
        if (!this.initialized) {
            throw new Error('Módulo não foi inicializado. Chame init() primeiro.');
        }

        this.container = container || this.config.container;
        if (!this.container) {
            throw new Error('Container é obrigatório');
        }

        const html = this.buildHTML();
        this.container.innerHTML = html;

        if (this.config.animateIn) {
            this.animateIn();
        }
    }

    /**
     * Constrói HTML do bloco
     * @private
     */
    buildHTML() {
        const { cssPrefix } = this.config;
        const { chamada_principal, imagem } = this.data;

        // Imagem padrão se não fornecida
        const imagemUrl = imagem;

        return `
      <div class="${cssPrefix}-container">
        <img 
          src="${this.escapeHtml(imagemUrl)}" 
          alt="Radar Agrozz"
          class="${cssPrefix}-image"
          width="188"
          height="104"
        />
        <p class="${cssPrefix}-text">${this.escapeHtml(chamada_principal)}</p>
      </div>
    `;
    }

    /**
     * Anima entrada do bloco
     * @private
     */
    animateIn() {
        const element = this.container.querySelector(`.${this.config.cssPrefix}-container`);
        if (element) {
            element.classList.add('fade-in');
        }
    }

    /**
     * Escapa HTML para prevenir XSS
     * @private
     */
    escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    /**
     * Atualiza conteúdo do bloco
     */
    update(newData) {
        this.data = { ...this.data, ...newData };
        if (this.container) {
            this.render(this.container);
        }
    }

    /**
     * Retorna CSS do módulo
     */
    static getStyles() {
        return `
      .mzk-bloco-container {
        display: flex;
        align-items: center;
        margin-top: 2.5rem;
        margin-bottom: 2.5rem;
        padding-bottom: 0.25rem;
        opacity: 0;
        transition: opacity 0.5s ease-in;
      }

      .mzk-bloco-container.fade-in {
        opacity: 1;
      }

      .mzk-bloco-image {
        width: 188px;
        height: auto;
        flex-shrink: 0;
      }

      .mzk-bloco-text {
        color: #56565f;
        padding-left: 1rem;
        font-size: 1.125rem;
        line-height: 1.75;
        margin: 0;
      }

      @media (max-width: 1024px) {
        .mzk-bloco-container {
          flex-direction: column;
          align-items: center;
        }

        .mzk-bloco-image {
          margin: 0 auto;
        }

        .mzk-bloco-text {
          padding-left: 0;
          padding-top: 1rem;
          text-align: center;
        }
      }
    `;
    }

    /**
     * Destrói o módulo
     */
    destroy() {
        if (this.container) {
            this.container.innerHTML = '';
        }
        this.data = null;
        super.destroy();
    }
}
